import { useState } from 'react';
import { AssignmentFormValues } from '../types';

export const useAssignmentForm = (initialValues?: Partial<AssignmentFormValues>) => {
  const [formValues, setFormValues] = useState<AssignmentFormValues>({
    group: "",
    deadlineDate: "",
    deadlineOffset: "",
    notify: false,
    mode: "update",
    ...initialValues
  });

  const handleFormChange = (values: Partial<AssignmentFormValues>) => {
    setFormValues(prev => ({ ...prev, ...values }));
  };

  return {
    formValues,
    handleFormChange,
    setFormValues
  };
};